// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TP12","col":"styles_col__1RtRN","actions":"styles_actions__6ioR7","conflict":"styles_conflict__2E_jO"};